export const setDate = (date: string) => ({
    type: 'APPOINTMENTS.SET_DATE',
    date: new Date(date),
});

export const setCellHeight = (
    cellHeight: ?number,
    headerCellHeight: ?number,
) => ({
    type: 'APPOINTMENTS.SET_CELL_HEIGHT',
    cellHeight,
    headerCellHeight,
});

export const setTab = (tab: string) => ({
    type: 'APPOINTMENTS.SET_TAB',
    tab,
});
